import { Static, Type } from '@sinclair/typebox';
import { SurveyWorkflowRoles } from './SurveyWorkflowRoles';

export const surveyWorkflowEmployeeTableSchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    userId: Type.String({ format: 'uuid' }),
    surveyId: Type.String({ format: 'uuid' }),
    workflowRole: Type.Enum(SurveyWorkflowRoles),
    shouldBeNotified: Type.Boolean(),
    remarks: Type.String(),
    created_at: Type.String(),
    updated_at: Type.String(),
});

/** Employees involved in a survey, can receive notifications for events. */
export type SurveyWorkflowEmployee = Static<typeof surveyWorkflowEmployeeTableSchema>;
